import { GamepadRoundRightIcon } from './GamepadRoundRightIcon';

/**
 * author: Haley Halcyon
 * id 4D10A9D6-5E25-457D-B4ED-25BCC647E62E
 * name gamepad-round-right
 * version: 3.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/gamepad-round-right.svg
 * tags
 * - Gaming / RPG 
 */
export const ControllerRoundRightIcon = GamepadRoundRightIcon;
export default ControllerRoundRightIcon